

<template>
    <div class="w-comment-wrapper">
        <div class="t-wra">
            <div class="rate-display">{{order.productName}}</div>
            <star :score="rate"
                mode="rate"
                @rate:change="(payload)=>rate=payload"></star>
        </div>
        <div class="reason-textarea-warapper">
            <van-field v-model="commentText"
                class="reason-textarea"
                type="textarea"
                placeholder="请输入评价，最多50个字"
                rows="5" />
            <div class="text-length">{{commentTextLength}}/50</div>
        </div>
        <div class="submit-btn iphonex-adapt-margin"
            @click="submit">
            <img v-if="isCostLoading" :src="loadingSrc" class="loading">
            <span v-else>确认提交</span></div>
    </div>
</template>

<script>
import Star from "@/components/common/Star.vue";
export default {
    name: "WriteComment",
    components: { Star },
    props: {},
    data() {
        return {
            rate: 5,
            commentText: "",
            order: {},
            loadingSrc: "",
            isCostLoading: false,
        };
    },
    computed: {
        commentTextLength() {
           return this.commentText.length;
        },
        type() {
            let type = 0;
            //评论类型：1.酒店；2.商品；3.景区，4.包车，5.线路
            switch (this.order.type) {
                case 1:
                case 2:
                case 3:
                    type = 3;
                    break;
                case 5:
                    type = 1;
                    break;
                case 9:
                    type = 5;
                    break;
                case 10:
                    type = 4;
                    break;
                case 21:
                case 22:
                    type = 2;
                    break;
                default:
                    break;
            }
            return type;
        }
    },
    watch: {
        
    },
    created() {
        let orderData = sessionStorage.orderData;
        if (!orderData) return;
        this.order = JSON.parse(orderData);
    },
    mounted() {
        this.loadingSrc = API.ossUrl + "common/loading.svg";
    },
    destroyed() {},
    methods: {
        submit() {
            if (this.commentText.trim() === "") {
                this.$alert("评价内容不能为空哦~");
                return false;
            }
            if (this.commentText.length > 50) {
                this.$alert("评价内容不能超过50个字！");
                return false;
            }
            this.postComment();
        },
        postComment() {
            if (this.isCostLoading) return;
            this.isCostLoading = true;
            let body = {
                type: this.type,
                product_id: this.order.productId,
                specs_id: this.order.specsId,
                content: this.commentText,
                score: this.rate,
                order_id:this.order.id
            };
            this.$axios
                .post(
                    `${window.API.order.postComment}?token=${
                        sessionStorage.token
                    }`,
                    body
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.$toast("提交评论成功！");
                        this.$router.push("/userOrderList?isHomePage=1");
                        sessionStorage.writeCommentFlag = "exit";
                        sessionStorage.writeCommentId = this.order.id;
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped lang="scss">
.van-cell:not(:last-child)::after {
    border-bottom: 0;
}
.w-comment-wrapper {
    min-height: 100%;
    background: $white;
    .t-wra {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0.533333rem 0 1.066667rem 0;
        .order-name {
            color: #333333;
            font-size: 15px;
            margin-bottom: 0.586667rem;
            font-weight: bold;
        }
        .rate-display {
            padding: 0 0.533333rem;
            margin-bottom: 0.8rem;
            font-size: 0.48rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color:#444444;
            line-height: 0.666667rem;
        }
    }
    .reason-textarea-warapper{
         position: relative;
        .reason-textarea {
            max-width: 8.933333rem;
            min-height: 9.066667rem;
            margin: 0 0.533333rem;
            border-radius: 0.16rem;
            border: 1px solid rgba(158,158,158,0.25);
            &.van-field {
                min-height: 9.066667rem;
                align-items: flex-start;
                font-size: 0.373333rem;
                font-family:PingFangSC-Regular;
                font-weight: 400;
                color: #8c8c8c;
                line-height: 0.533333rem;
                .van-field__body{
                    textarea::-webkit-input-placeholder{
                    font-size: 0.373333rem;
                    font-family:PingFangSC-Regular;
                    font-weight: 400;
                    color: #8c8c8c;
                    line-height: 0.533333rem;
                    }
                }
                
            }
        }
         .text-length{
            position: absolute;
            bottom: 0.16rem;
            right: 0.8rem;
            font-size: 0.373333rem;
            font-family:PingFangSC-Regular;
            font-weight: 400;
            color: #8c8c8c;
            line-height: 0.533333rem;
        }
    }
    .submit-btn {
        width: 8.88rem;
        height: 1.173333rem;
        background: linear-gradient(90deg,rgba(248,199,64,1) 0%,rgba(245,149,38,1) 100%);
        border-radius: 0.586667rem;
        position: fixed;
        bottom: 1.44rem;
        left: 0;
        right: 0;
        margin: auto;
        color: $white;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
    }
}
</style>

